// src/components/usuario/TutorialAyuda.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import HeaderUsuario from "../header/HeaderUsuario";
import backgroundImage from "../../assets/img/fondoSeis.png";
import logoCIE from "../../assets/img/logoBlancoCIE.svg";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const TutorialAyuda = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const u = localStorage.getItem("usuario");
    if (u) {
      try {
        const parsed = JSON.parse(u);
        setUserName(parsed?.nombre || parsed?.name || null);
      } catch {}
    }

    const fetchVideo = async () => {
      try {
        const token = localStorage.getItem("token");
        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        // 1) Nuevo endpoint
        try {
          const { data } = await axios.get(
            `${API_BASE_URL}/api/tutorial-video`,
            { headers }
          );
          if (data?.url) {
            setVideoUrl(data.url); // ya viene con ?t=...
            return;
          }
        } catch {
          // continúa al fallback
        }

        // 2) Fallback al endpoint anterior
        try {
          const { data } = await axios.get(`${API_BASE_URL}/api/video`, {
            headers,
          });
          if (data?.rutaArchivo) {
            setVideoUrl(`${API_BASE_URL}${data.rutaArchivo}?t=${Date.now()}`);
            return;
          }
        } catch {
          // sin video
        }

        setVideoUrl(null);
      } finally {
        setCargando(false);
      }
    };

    fetchVideo();
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col font-montserrat relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Header con menú (niveles, admin, logout, ayuda, etc.) */}
      <div className="absolute top-4 right-4 z-10">
        <HeaderUsuario />
      </div>

      {/* Contenido */}
      <div className="flex-grow flex justify-center items-start mt-16 px-4">
        <div className="w-full max-w-4xl bg-white/80 rounded-2xl shadow-xl p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-[#00733A] mb-2">
            Saludos{userName ? `, ${userName}` : ""}!
          </h1>
          <p className="text-gray-700 mb-6">
            Este es el{" "}
            <span className="font-semibold">
              tutorial de la App Identidad Institucional
            </span>
            . Aquí te mostramos cómo navegar, completar niveles y aprovechar
            todas las funciones.
          </p>

          {cargando ? (
            <p className="text-gray-700">Cargando tutorial…</p>
          ) : videoUrl ? (
            <video
              key={videoUrl}
              controls
              playsInline
              preload="metadata"
              className="w-full rounded-xl shadow-lg"
              src={videoUrl}
            />
          ) : (
            <div className="text-gray-700">
              <p>No hay video tutorial disponible por ahora.</p>
              <p className="text-sm mt-1">
                Intenta más tarde o contacta al administrador.
              </p>
            </div>
          )}

          <div className="mt-6 flex justify-center">
            <Link to="/niveles">
              <button className="bg-green-700 text-white font-bold py-2 px-4 rounded transform hover:scale-105 transition">
                Ir a niveles
              </button>
            </Link>
          </div>
        </div>
      </div>

      {/* Logo CIE abajo derecha */}
      <div className="absolute bottom-8 right-8">
        <img src={logoCIE} alt="Logo CIE" className="h-auto w-auto" />
      </div>
    </div>
  );
};

export default TutorialAyuda;
